import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().top < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-116" data-mp="2avb971xpodur">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" data-id="element-117" data-mp="38ap6uupb06ci">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 whitespace-nowrap rounded-2xl border-b-[5px] border-cta-shadow bg-cta px-5 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-white shadow-[0_12px_32px_-6px_rgba(0,0,0,0.45)] hover:bg-cta-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-gold" data-id="element-118" data-mp="333azpawnb2qj">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-119" data-mp="2kdumbmzv3fsp" />
            Get instant access — $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}